import React, { HTMLAttributes, useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
// import store from "store";
import { get_searchMarketHot } from "api/old/xt-app";

import XtLoading from "@/components/xt/loading";
import AppDivNoData from "@/components/app/div/noData";

import CMPT_Main from "./main";

import styles from "./index.module.scss";

interface Props extends HTMLAttributes<HTMLDivElement> {
  visible: boolean;
  setSearchInputFocus: () => void;
  isShowVolume: boolean;
}

const Main: React.FC<Props> = ({ className, visible, setSearchInputFocus, isShowVolume }) => {
  const t = useTranslation();

  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState<string[]>([]);

  useEffect(() => {
    if (!visible || records.length) return;
    setLoading(true);
    get_searchMarketHot()
      .then((data) => {
        const ary: string[] = [];
        data.map((obj) => {
          if ([1, 4].includes(obj.type) && !ary.includes(obj.marketName)) {
            //1.现货 4.杠杆 8.全币种合约 10.币本位合约 11.U本位合约
            ary.push(obj.marketName);
          }
        });
        setRecords(ary);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [visible]);

  return (
    <div className={cx(styles.main, className, { [styles.hide]: !visible })} onMouseDown={setSearchInputFocus} onTouchStart={setSearchInputFocus}>
      <div className={styles.nav}>{t("trade.topSearch")}</div>
      <div className={styles.content}>
        {loading && <XtLoading className={styles.loading} />}
        {!loading && !records.length && <AppDivNoData />}
        {visible && !loading && !!records.length && <CMPT_Main records={records} isShowVolume={isShowVolume} />}
      </div>
    </div>
  );
};

export default observer(Main);
// export default Main;
